import { Card, CardContent } from "@/components/ui/library/card";
import CourseHeader from "./components/CourseHeader";
import CourseInfoCards from "./components/CourseInfoCards";
import ProgramOverview from "./components/ProgramOverview";
import Eligibility from "./components/Eligibility";
// import Scholarships from "./components/Scholarships";
import CourseBrochure from "./components/CourseBrochure";
import { useAppSelector } from "@/stores/hook";
import { useDispatch } from "react-redux";
import { getBadgeColor } from "@/utils/convetors";
import useCurrentCourse from "@/features/universityAndCourse/api/useCurrentCourse";
import { useSyncronizer } from "@/hooks/useSyncronizer";
import {
  setCourseDetailId,
  setIsCourseDetails,
} from "@/module/education/stores/educationSlice";
import PreferenceViewer from "@/components/ui/others/PrefrenceRenderers/PrefrenceViewer";

export default function CourseDetails() {
  const { courseDetailId } = useAppSelector((state) => state.educationSlice);
  const dispatch = useDispatch();
  const { course: curCourse, refetch } = useCurrentCourse(courseDetailId);
  useSyncronizer(courseDetailId, () => refetch());

  const handleBackClick = () => {
    dispatch(setCourseDetailId(null));
    dispatch(setIsCourseDetails(false));
  };

  if (!curCourse) {
    return (
      <Card className="border-[var(--color-black-1)] rounded-[16px]">
        <CardContent className="p-8 text-center">
          <p className="text-[var(--color-black-7)]">No course selected</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="border-[var(--color-black-1)] rounded-[16px] bg-white py-2">
      <CardContent className="px-0">
        <div className="flex flex-col">
          {/* Header Section */}
          <div className="px-3">
            <CourseHeader
              courseName={curCourse.name}
              university={curCourse.university.name}
              courseType={curCourse.courseType}
              level={curCourse.qualificationLevel.name}
              courseTypeBgColor={getBadgeColor(curCourse.courseType)}
              onBackClick={handleBackClick}
            />
          </div>

          {/* Content Section */}
          <div className="flex-1 flex flex-col pt-4 px-5 pb-0 w-full">
            <CourseInfoCards
              location={`${curCourse.university.city}`}
              tuitionFee={
                Number(curCourse.minFee) > 0
                  ? `${curCourse.minFee} ${curCourse.university.currency || ""}`
                  : "Not specified"
              }
              duration={`${curCourse.duration}-Months`}
            />
            <ProgramOverview
              overview={
                curCourse.description && curCourse.description.trim().length > 0
                  ? curCourse.description
                  : "No description is available for this course at the moment."
              }
              secondPara={curCourse.university.description || null}
            />

            {/* 1. Check if customInputs exists */}
            {curCourse?.customInputs &&
              // 2. Convert Object { key: value } -> Array [ [key, value], ... ]
              Object.entries(curCourse.customInputs).map(([key, value]) => (
                <PreferenceViewer
                  key={key}
                  // Capitalize the key for a nicer title (e.g., "intakes" -> "Intakes")
                  title={
                    curCourse?.customInputLabels?.[key] ??
                    key.charAt(0).toUpperCase() + key.slice(1)
                  }
                  // Pass the value (String or Array) to the prop we defined
                  customInputsValue={value}
                />
              ))}

            <Eligibility eligibilities={curCourse.eligibility} />
            {/* <Scholarships /> */}
            <CourseBrochure />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
